import styled from 'styled-components'
import { colors } from '../../../../styles/constants'

export const Container = styled.div`
  width:100%;
  margin:0 auto;
  padding: 0 16px;
`
export const InfoCard = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  margin-top: 16px;
  color: ${colors.gray.dark};
  strong {
    font-family: 'Open Sans' !important;
    font-weight: 600;
  }
`

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  h1 {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${colors.gray.darker};
    margin-bottom: 0;
  }
`
export const ClientsInfo = styled.div`
  margin: 24px 0;
`
export const Skeleton = styled.div`
  margin-bottom: 16px;
`
export const DataInfo = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
`
